module.exports = "<div class=\"mat-caption\" matTooltip=\"{{ version.time | date:'yyyy-MM-dd HH:mm:ss' }} (git {{ version.hash }})\">\n  <strong>ui:</strong> {{ version.version }} [{{ version.time | date:'yyyy-MM-dd HH:mm:ss' }}] (git {{ version.hash }})\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/frontend-version/frontend-version.component.html
// module id = ./src/app/shared/components/frontend-version/frontend-version.component.html
// module chunks = main